import React, {
  useEffect,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  FiCalendar,
  FiFilter,
  FiRefreshCw,
  FiSearch,
  FiX,
} from "react-icons/fi";


function ReviewsFilter({
  titleAr,
  setTitleAr,

  titleEn,
  setTitleEn,

  date,
  setDate,
}) {
  const {
    t,
  } = useTranslation();


  /* =====================================
      DRAFT VALUES
  ====================================== */

  const [
    fTitleAr,
    setFTitleAr,
  ] = useState(
    titleAr || ""
  );


  const [
    fTitleEn,
    setFTitleEn,
  ] = useState(
    titleEn || ""
  );


  const [
    fDate,
    setFDate,
  ] = useState(
    date || ""
  );


  /* =====================================
      SYNC
  ====================================== */

  useEffect(() => {
    setFTitleAr(
      titleAr || ""
    );
  }, [
    titleAr,
  ]);


  useEffect(() => {
    setFTitleEn(
      titleEn || ""
    );
  }, [
    titleEn,
  ]);


  useEffect(() => {
    setFDate(
      date || ""
    );
  }, [
    date,
  ]);


  /* =====================================
      SEARCH
  ====================================== */

  const handleSearch = () => {

    setTitleAr(
      fTitleAr.trim()
    );

    setTitleEn(
      fTitleEn.trim()
    );

    setDate(
      fDate
    );

  };


  /* =====================================
      RESET
  ====================================== */

  const handleReset = () => {

    setFTitleAr("");
    setFTitleEn("");
    setFDate("");

    setTitleAr("");
    setTitleEn("");
    setDate("");

  };


  /* =====================================
      CLEAR
  ====================================== */

  const clearArabic = () => {

    setFTitleAr("");
    setTitleAr("");

  };


  const clearEnglish = () => {

    setFTitleEn("");
    setTitleEn("");

  };


  const clearDate = () => {

    setFDate("");
    setDate("");

  };


  /* =====================================
      ENTER
  ====================================== */

  const handleKeyDown =
    (e) => {

      if (
        e.key === "Enter"
      ) {
        e.preventDefault();

        handleSearch();
      }

    };


  const hasDraftFilters =
    Boolean(
      fTitleAr ||
      fTitleEn ||
      fDate
    );


  const hasActiveFilters =
    Boolean(
      titleAr ||
      titleEn ||
      date
    );


  return (
    <div
      className="
        w-full
      "
    >

      {/* =================================
          FILTERS
      ================================= */}

      <div
        className="
          grid

          grid-cols-1
          md:grid-cols-2

          xl:grid-cols-[1fr_1fr_.8fr_auto]

          gap-3

          items-end
        "
      >

        {/* Arabic Name */}

        <FilterField
          label={t(
            "Name (Ar)"
          )}

          icon={
            <FiSearch
              size={15}
            />
          }
        >

          <input
            type="text"

            dir="rtl"

            value={
              fTitleAr
            }

            onChange={(
              e
            ) =>
              setFTitleAr(
                e.target.value
              )
            }

            onKeyDown={
              handleKeyDown
            }

            placeholder={t(
              "Search Arabic customer name"
            )}

            className="
              w-full
              h-full

              bg-transparent

              px-1

              font-kufi
              text-xs

              text-color-2
              dark:text-white

              placeholder:text-color-2/30
              dark:placeholder:text-white/25

              outline-none
            "
          />


          {fTitleAr && (

            <ClearButton
              onClick={() =>
                setFTitleAr("")
              }
            />

          )}

        </FilterField>


        {/* English Name */}

        <FilterField
          label={t(
            "Name (En)"
          )}

          icon={
            <FiSearch
              size={15}
            />
          }
        >

          <input
            type="text"

            dir="ltr"

            value={
              fTitleEn
            }

            onChange={(
              e
            ) =>
              setFTitleEn(
                e.target.value
              )
            }

            onKeyDown={
              handleKeyDown
            }

            placeholder={t(
              "Search English customer name"
            )}

            className="
              w-full
              h-full

              bg-transparent

              px-1

              text-xs

              text-color-2
              dark:text-white

              placeholder:text-color-2/30
              dark:placeholder:text-white/25

              outline-none
            "
          />


          {fTitleEn && (

            <ClearButton
              onClick={() =>
                setFTitleEn("")
              }
            />

          )}

        </FilterField>


        {/* Date */}

        <FilterField
          label={t(
            "Review Date"
          )}

          icon={
            <FiCalendar
              size={15}
            />
          }
        >

          <input
            type="date"

            value={
              fDate
            }

            onChange={(
              e
            ) =>
              setFDate(
                e.target.value
              )
            }

            className="
              w-full
              h-full

              bg-transparent

              px-1

              font-kufi
              text-[11px]

              text-color-2
              dark:text-white

              outline-none
            "
          />


          {fDate && (

            <ClearButton
              onClick={() =>
                setFDate("")
              }
            />

          )}

        </FilterField>


        {/* Actions */}

        <div
          className="
            flex

            md:col-span-2
            xl:col-span-1

            items-center

            gap-2
          "
        >

          <button
            type="button"

            onClick={
              handleSearch
            }

            className="
              flex

              h-[48px]

              flex-1
              xl:flex-none

              items-center
              justify-center

              gap-2

              rounded-[1rem]

              bg-color-1

              px-5

              font-kufi
              font-semibold

              text-[11px]

              text-white

              transition-all

              hover:bg-color-2

              hover:shadow-[0_8px_22px_rgba(165,119,58,.22)]
            "
          >
            <FiSearch />

            {t(
              "Search"
            )}
          </button>


          <button
            type="button"

            onClick={
              handleReset
            }

            disabled={
              !hasDraftFilters &&
              !hasActiveFilters
            }

            className="
              flex

              w-[48px]
              h-[48px]

              shrink-0

              items-center
              justify-center

              rounded-[1rem]

              border
              border-color-1/15

              bg-color-1/5

              text-color-1

              transition-all

              hover:bg-color-1
              hover:text-white

              disabled:opacity-30
              disabled:cursor-not-allowed
            "
          >
            <FiRefreshCw />
          </button>

        </div>

      </div>


      {/* =================================
          ACTIVE FILTERS
      ================================= */}

      {hasActiveFilters && (

        <div
          className="
            flex
            flex-wrap

            items-center

            gap-2

            mt-4
            pt-4

            border-t
            border-color-2/[0.07]
            dark:border-white/[0.07]
          "
        >

          <div
            className="
              flex

              items-center

              gap-2

              font-kufi
              text-[9px]

              text-color-2/45
              dark:text-white/35
            "
          >
            <FiFilter
              className="
                text-color-1
              "
            />

            {t(
              "Active Filters"
            )}
          </div>


          {titleAr && (

            <FilterChip
              label={
                titleAr
              }

              onRemove={
                clearArabic
              }
            />

          )}


          {titleEn && (

            <FilterChip
              label={
                titleEn
              }

              onRemove={
                clearEnglish
              }
            />

          )}


          {date && (

            <FilterChip
              icon={
                <FiCalendar
                  size={10}
                />
              }

              label={
                date
              }

              onRemove={
                clearDate
              }
            />

          )}


          <button
            type="button"

            onClick={
              handleReset
            }

            className="
              flex

              items-center

              gap-1.5

              rounded-full

              border
              border-color-2/10

              px-3
              py-1.5

              font-kufi
              text-[9px]

              text-color-2/45

              transition-all

              hover:bg-red-500/[0.05]
              hover:text-red-500
            "
          >
            <FiRefreshCw />

            {t(
              "Clear All"
            )}
          </button>

        </div>

      )}

    </div>
  );
}


/* =====================================
    FIELD
====================================== */

function FilterField({
  label,
  icon,
  children,
}) {
  return (
    <div
      className="
        w-full
      "
    >

      <label
        className="
          block

          mb-2

          font-kufi
          font-medium

          text-[10px]
          md:text-[11px]

          text-color-2/60
          dark:text-white/50
        "
      >
        {label}
      </label>


      <div
        className="
          flex

          h-[48px]

          items-center

          overflow-hidden

          rounded-[1rem]

          border
          border-color-2/10
          dark:border-white/10

          bg-back-secondary/60
          dark:bg-back-darkprimery/60

          transition-all

          focus-within:border-color-1/60

          focus-within:shadow-[0_0_0_3px_rgba(165,119,58,.08)]
        "
      >

        <div
          className="
            flex

            w-11
            h-full

            shrink-0

            items-center
            justify-center

            text-color-1
          "
        >
          {icon}
        </div>


        {children}

      </div>

    </div>
  );
}


/* =====================================
    CLEAR BUTTON
====================================== */

function ClearButton({
  onClick,
}) {
  return (
    <button
      type="button"

      onClick={
        onClick
      }

      className="
        flex

        w-10
        h-full

        shrink-0

        items-center
        justify-center

        text-color-2/30

        transition-colors

        hover:text-color-1
      "
    >
      <FiX
        size={14}
      />
    </button>
  );
}


/* =====================================
    CHIP
====================================== */

function FilterChip({
  label,
  icon,
  onRemove,
}) {
  return (
    <button
      type="button"

      onClick={
        onRemove
      }

      className="
        inline-flex

        max-w-[200px]

        items-center

        gap-2

        rounded-full

        border
        border-color-1/10

        bg-color-1/10

        px-3
        py-1.5

        font-kufi
        text-[9px]

        text-color-1

        transition-all

        hover:bg-color-1
        hover:text-white
      "
    >

      {icon}


      <span
        className="
          truncate
        "
      >
        {label}
      </span>


      <FiX
        size={10}
      />

    </button>
  );
}


export default ReviewsFilter;